import LIVR from 'livr';
import $ from 'jquery';
import ErrorCodes from 'ReactApp/Services/Validator/ErrorCodes';
import Validator from 'ReactApp/Services/Validator/Validator';

/**
 * Copy of the app/frontend/assets/js/services/validator/ValidatorInit.js
 * that is used in ReactApp and in feature MUST BE replace to special components
 */

var requiredAsMessage = function(value) {
    if (!value) throw "[value] parameter required";

    return function(val) {
        if (!val) {
            return 'REQUIRED_AS_MESSAGE';
        }

        return;
    }
};

var russianMobilePhone = function(value) {
    if (!value) throw "[value] parameter required";

    return function(val) {
        let clearVal = val.replace(/\D/g, '');
        if (clearVal[0] == '7') {
            clearVal = clearVal.slice(1);
        }
            
        if (clearVal.length !== 10 || clearVal[0] != '9') {
            return 'NO_RUSSIAN_MOBILE_PHONE';
        }

        return;
    }
};

var russianPhone = function(value) {
    if (!value) throw "[value] parameter required";

    return function(val) {
        let clearVal = val.replace(/\D/g, '');
        if (clearVal[0] == '7') {
            clearVal = clearVal.slice(1);
        }
            
        if (clearVal.length !== 10) {
            return 'NO_RUSSIAN_PHONE';
        }

        return;
    }
};

LIVR.Validator.registerDefaultRules({
    russian_mobile_phone: russianMobilePhone,
    russian_phone: russianPhone,
    required_as_message: requiredAsMessage,
});

export function showError(
    validatorOrErrorObject: LIVR.Validator | { [key: string]: any }, 
    validatonSchema: CommonNs.ValidationSchemaInterface,
    formName: string | null = null,
): JQuery<HTMLElement> | null {

    let firstErrorEl: JQuery<HTMLElement> | null = null;
    let numberOfErrors: number = 0;

    let showErrorInner = (
        validatorOrErrorObject: LIVR.Validator | { [key: string]: any }, 
        validatonSchema: CommonNs.ValidationSchemaInterface,
        formName: string | null = null,
    ): JQuery<HTMLElement> | null => {
        Object.entries(
            typeof validatorOrErrorObject.getErrors === 'function' 
                ? validatorOrErrorObject.getErrors()
                : validatorOrErrorObject
        ).forEach(([name, errCodeOrNestedObject]) => {
            
            if (typeof errCodeOrNestedObject === 'object') {
                // recursively
                firstErrorEl = showErrorInner(
                    errCodeOrNestedObject,
                    validatonSchema[name].nestedObject as CommonNs.ValidationSchemaInterface,
                    formName,
                );
                // \recursively
            } else {
                let bySearch: string | undefined = undefined;
                if (validatonSchema[name].fieldName !== undefined) {
                    bySearch = `[name="${formName ?? ''}${validatonSchema[name].fieldName}"]`;
                } else if (validatonSchema[name].selector !== undefined) {
                    bySearch = validatonSchema[name].selector;
                }

                if (bySearch === undefined) {
                    return;
                }

                const el = $(bySearch);
                if (numberOfErrors === 0) {
                    firstErrorEl = el;
                }
                if (el.length) {
                    switch (errCodeOrNestedObject) {
                        case ErrorCodes.REQUIRED:
                            el.addClass('_error');
                        break;
                        default:
                            let invalidFeedbackEl: JQuery | undefined = undefined;
                            if (validatonSchema[name].fieldName !== undefined) {
                                invalidFeedbackEl = el.next('.invalid-feedback');
                            } else if (validatonSchema[name].selector !== undefined) {
                                invalidFeedbackEl = el.find('.invalid-feedback');
                            }

                            if (invalidFeedbackEl === undefined) {
                                return;
                            }

                            invalidFeedbackEl
                                .addClass('show')
                                .empty()
                                .html(
                                    (
                                        $('<p>', {
                                            class: '_alert _alert-error',
                                        }).html(Validator.generateError(
                                            errCodeOrNestedObject, 
                                            validatonSchema[name].messageReplacements || {}
                                        ))
                                    ) as unknown as string
                                );
                        break;
                    }
                }
                numberOfErrors++; 
            }
            
        });
        return firstErrorEl;
    }

    showErrorInner(
        validatorOrErrorObject,
        validatonSchema,
        formName
    );

    
    return firstErrorEl;
}

export default LIVR;